$('document').ready(function () {
    // open/close nav by hamburger
    $('#mobile .nav-container .hamburger').on('click', function () {
        if (!$('header.header').hasClass('mobile-nav-on')) {
            openMobileNav($(this));
        } else {
            closeMobileNav($(this));
        }
    });

    // close nav at bottom of nav
    $('#mobile .nav-container #close-mobile-nav').on('click', function () {
        closeMobileNav($('#mobile .nav-container .hamburger'));
    });
    $(".support-layout .support-nav #language-selector > span").on('click', function () {
        $(this).parent().toggleClass("active");
    })

    // open subnav
    //$('#mobile .nav-container ul.main-nav li a.nav-dropdown, #mobile .nav-container ul.main-nav li img, #mobile .nav-container ul.eyebrow-nav li a#language-selector, #mobile .nav-container ul.eyebrow-nav li img').on('click', function (e) {
    $('#mobile .nav-container ul.main-nav li, #mobile .nav-container ul.eyebrow-nav li').on('click', function (e) {
        //e.preventDefault();
        var $eTarget = $(e.target);
        var $targetLi = null;
        if ($eTarget.prop("nodeName") == "LI" && $eTarget.find(".subnav").length) {
            $targetLi = $eTarget;
        } else if ($eTarget.prop("nodeName") != "LI" && $eTarget.siblings(".subnav").length) {
            $targetLi = $(this);
        }
        if ($targetLi != null && $targetLi.length) {

            // get image element
            //var $el = $(this).prop('nodeName') === 'A' ? $(this).siblings('img') : $(this);
            var $el = $targetLi.find('img');

            if (!$el.siblings('ul.subnav').is(':visible')) {
                openSubNav($el);
            } else {
                closeSubNav($el);
            }
        }
    });

    // desktop navigation on scroll
    $(window).on('scroll', function () {
        handleNavScroll();
    });

    // desktop navigation on resize
    $(window).resize(function () {
        if (BreakpointDetection.is("xl")) {
            $('header.header').removeClass('mobile-fixed');
        } else {
            $('header.header').removeClass('desktop-fixed');
        }

        handleNavScroll();
    });

    // mega-nav events
    $(".nav-list-item").on("mouseover", function () {
        var $this = $(this);
        var control = $this.attr("data-group-control");
        $this.parent().find(".nav-list-item").removeClass("active");
        $this.addClass("active");

        var $subnav = $this.closest(".mega-subnav")
        $subnav.find(".nav-links-container").removeClass("active");
        $subnav.find(".nav-links-container[data-group-id=" + control + "]").addClass("active");
        $subnav.find(".promo-child-container").removeClass("active");
        $subnav.find(".promo-child-container[data-group-id=" + control + "]").addClass("active");
    });

    // footer back to top
    $('footer .footer-logo #back-to-top').on('click', function (e) {
        e.preventDefault();

        $('html, body').animate({
            scrollTop: 0
        }, 1000);
    });
});

function openMobileNav(el) {
    el.attr('src', '/Assets/icons/content/icon-menu-close.svg');
    $('header.header').addClass('mobile-nav-on');
    $('#mobile .nav-container').addClass('mobile-nav-on');
    $('body').addClass('mobile-nav-on');
    $('#mobile .nav-container .menu-container').css('height', $(window).height() - $('header.header').height());
    $('#mobile .nav-container .menu-container').show();

    // reset nav in case the user left anything open
    resetNav();
}

function closeMobileNav(el) {
    el.attr('src', '/Assets/icons/content/icon-menu.svg');
    $('header.header').removeClass('mobile-nav-on');
    $('#mobile .nav-container').removeClass('mobile-nav-on');
    $('#mobile .nav-container .menu-container').hide();
    $('body').removeClass('mobile-nav-on');
}

function openSubNav(el) {
    el.attr('src', '/Assets/icons/content/icon-chevron-up.svg');
    el.siblings('ul.subnav').show();
}

function closeSubNav(el) {
    el.attr('src', '/Assets/icons/content/icon-chevron-down.svg');
    el.siblings('ul.subnav').hide();
}

function resetNav() {
    $('#mobile .nav-container .menu-container ul.subnav').hide();
    $('#mobile .nav-container .menu-container ul.main-nav li img').attr('src', '/Assets/icons/content/icon-chevron-down.svg');
    $('#mobile .nav-container .menu-container ul.eyebrow-nav li a#language-selector').siblings('img').attr('src', '/Assets/icons/content/icon-chevron-down.svg');
}

var lastScrollTop = 0;
function handleNavScroll() {
    //var scrollTop = $(this).scrollTop();
    var scrollTop = $('html').scrollTop() || $('body').scrollTop();
    var eyebrowSize = 0;
    if ($("#desktop .eyebrow-nav").length) {
        eyebrowSize = BreakpointDetection.is("xl") ? $("#desktop .eyebrow-nav")[0].getBoundingClientRect().height : 0;
    }
    var offsetToCheck = $(".announcement-bar").length ? $(".announcement-bar")[0].getBoundingClientRect().height : 35;

    if (scrollTop > lastScrollTop) {//direction control
        // downscroll
        if (scrollTop > (offsetToCheck + eyebrowSize)) {
            if (BreakpointDetection.is("xl")) {
                $('header.header').addClass('desktop-fixed');
            } else {
                $('header.header').addClass('mobile-fixed');
            }

            $('header.header').removeClass('scroll-up');
        }
    } else {
        // upscroll
        if (scrollTop > (offsetToCheck)) {
            $('header.header').addClass('scroll-up');
            $('header.header').removeClass('has-announcement-bar');
        } else if ($('header.header').hasClass('announcement-bar-is-vis')) {
            $('header.header').addClass('has-announcement-bar');

            if (BreakpointDetection.is("xl")) {
                $('header.header').removeClass('desktop-fixed');
            } else {
                $('header.header').removeClass('mobile-fixed');
            }
        }
    }
    lastScrollTop = scrollTop;
}


// Wrap IIFE around your code
//(function ($, viewport) {
//    $(document).ready(function () {

//        // Execute code each time window size changes
//        $(window).resize(
//            viewport.changed(function () {
//                console.log(viewport.is());
//            })
//        );

//    });
//})(jQuery, BreakpointDetection);